<template>
  <div class="section">
    <h1>Portfolio</h1>
  </div>
</template>

<script>
export default {
}
</script>
<style scoped>

</style>

 <!-- Ideas: Slideshow Eagle.js, Carousel -->
